module.exports = __webpack_public_path__ + "static/media/Page-2.4e2a83de.jpg";